import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { FormattedMessageWrappedInSpan } from '../../misc';

import { AddFilled } from '@carbon/icons-react';

const MediaListAdditionalPhotoTile = ({ type, onClick }) => {
  const defineTileTexts = () => {
    switch (type) {
      case 'pending':
        return (
          <FormattedMessageWrappedInSpan
            className="typography typography-caption_small"
            id="mediaListAdditionalPhotoTile.moreMightBeAdded"
            defaultMessage="More photos will be added automatically to your package if found"
          />
        );
      case 'addCombined':
        return (
          <FormattedMessageWrappedInSpan
            className="typography uppercase typography-title_xsmall"
            id="mediaListAdditionalPhotoTile.addMoreByFace"
            defaultMessage="Add even more"
          />
        );
    }
  };

  const defineTileIcon = () => {
    switch (type) {
      case 'pending':
      case 'addCombined':
        return <AddFilled />;
    }
  };

  return (
    <div
      className="medialist-item-container"
      onClick={() => {
        onClick && onClick();
      }}
    >
      <div
        className={classNames('medialist-additional-photo', {
          primary: type === 'addCombined',
          secondary: type === 'pending',
          interactive: Boolean(onClick)
        })}
      >
        <div className="medialist-additional-photo_icon">{defineTileIcon()}</div>
        <div className="medialist-additional-photo_text">{defineTileTexts()}</div>
      </div>
    </div>
  );
};

MediaListAdditionalPhotoTile.propTypes = {
  type: PropTypes.oneOf(['pending', 'addCombined']),
  onClick: PropTypes.func,
};

export default MediaListAdditionalPhotoTile;
